<template>

    <div class="article">
        <section class="section section-shaped my-0 pb-xs">
            <div class="shape shape-style-1 shape-primary wsu">
            </div>
            <div class="container">
                <div class="row my-0 py-0">
                    <div class="col-lg-12">
                        <h1 v-if="post" class="title text-center my-0 py-0"><center>EDUCATIONAL DATABASE</center></h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-2">&nbsp;</div>
                    <div class="col-lg-8">
                        <p class="subtitle" v-html="subtitle"></p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section article-body py-0">
            <div class="container" v-if="post">
                <div class="row">
                    <div class="col-lg-6 loading" v-if="loading">
                        <h1>&nbsp;</h1>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-lg-8" v-if="!loading">
                        <card class="card-article my-0">
                            <template slot="header">
                                <span v-bind:style="[(post.format.color.length >= 4) ? {'color': post.format.color} : {'color': '#29529b'}]">
                                        <i v-if="post.format.icon.length >= 4" v-bind:class="'fa ' + post.format.icon"></i>
                                        <i v-if="post.format.icon.length < 4" class="fa fa-list"></i>
                                        &nbsp;{{post.format.name}}
                                    </span>

                                <base-button class="btn-3 btn-sm pull-right" type="link" @click="$router.go(-1)">BACK</base-button>
                            </template>
                            <h2>{{post.title}}</h2>
                            <div class="row mt-0 pb-2 text-italic">
                                <div class="col-lg-4">
                                    <small>
                                Level:
                                <template v-for="(value, key) in post['levels']">
                                    {{value.name.split(' ').join('&nbsp;')}}
                                </template>
                                </small>
                                </div>
                                <div class="col-lg-4">
                                    <small>
                                    Date:
                                    <span v-if="post.day">{{ten_number(post.day)}}</span>&nbsp;<span v-if="post.month">{{getMonth(post.month - 1)}}</span>&nbsp;{{post.year}}
                                </small>
                                </div>
                                <div class="col-lg-4">
                                    <small>
                                    Location: {{post.place.name}}
                                </small>
                                </div>
                            </div>
                            <span v-html="post.abstract"></span>
                            <template slot="footer">
                                <div class="text-center">
                                    <small>
                                    <center>
                                            <template v-if="post.access.toLowerCase() == 'registration required'">
                                                <font-awesome-icon icon="lock" class="access-icon"/>
                                            </template>
                                            <template v-if="post.access.toLowerCase() == 'open access'">
                                                <font-awesome-icon icon="lock-open" class="access-icon"/>
                                            </template>
                                            <template v-if="post.access.toLowerCase() == 'member privilege'">
                                                <font-awesome-icon icon="lock" class="access-icon"/>
                                            </template>
                                            <span class="ml-1" v-on:click="filter_add('access',post.access)">{{post.access}}</span>
                                    </center>
                                </small>
                                </div>
                            </template>
                        </card>
                        <card class="card-how_to_access mt-0 mb-3 ">
                            <div class="text-magenta" v-html="post.how_to_access"></div>
                        </card>

                    </div>
                    <div class="col-lg-4" v-if="!loading">
                        <a :href="post.weblink" class="btn btn-block btn-3 btn-primary text-uppercase" target="_blank">
                            <i class="fa fa-external-link"></i> &nbsp;Access
                        </a>
                        <card class="my-3 card-tags">
                            <template slot="header">
                                <div class="text-default text-center">
                                    <small>TAGS</small>
                                </div>
                            </template>
                            <div class="tags text-center">
                                <template v-for="category in ['format', 'type']">
                                    <span class="badge cursor-pointer" v-on:click="search(category,post[category].name)" v-bind:style="[(post.format.color.length >= 4) ? {'backgroundColor': post.format.color} : {'backgroundColor': '#29529b'}]">{{post[category].name.split(' ').join('&nbsp;')}}</span>
                                </template>
                                <template v-for="category in [['level','levels'], ['pathology', 'pathologies'], ['anatomical', 'anatomical_segments']]">
                                    <template v-for="(value, key) in post[category[1]]">
                                        <span class="badge cursor-pointer" v-if="value.name.toLowerCase()!='All'.toLowerCase()" v-on:click="search(category[0],value.name)" v-bind:style="[(post.format.color.length >= 4) ? {'backgroundColor': post.format.color} : {'backgroundColor': '#29529b'}]">{{value.name.split(' ').join('&nbsp;')}}</span>
                                    </template>
                                </template>
                                <template v-for="category in [['language', 'languages']]">
                                    <template v-for="(value, key) in post[category[1]]">
                                        <span class="badge cursor-pointer" v-on:click="search(category[0],value.display_name)" v-bind:style="[(post.format.color.length >= 4) ? {'backgroundColor': post.format.color} : {'backgroundColor': '#29529b'}]">{{value.display_name.split(' ').join('&nbsp;')}}</span>
                                    </template>
                                </template>
                                <template v-for="category in ['place','region']">
                                    <span class="badge cursor-pointer" v-on:click="search(category,post[category].name)" v-bind:style="[(post.format.color.length >= 4) ? {'backgroundColor': post.format.color} : {'backgroundColor': '#29529b'}]">{{post[category].name.split(' ').join('&nbsp;')}}</span>
                                </template>
                            </div>
                        </card>
                    </div>
                </div>
            </div>
        </section>
    </div>

</template>

<style>
    .article .section-shaped .shape-style-1.shape-primary.wsu {
        /* uigradients.com */
        background: #042D98;
        background-image: url('./../assets/img/vortex.jpg');
        background-repeat: no-repeat;
        background-position: left;
        background-size: cover;
/*        -webkit-box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);
        box-shadow: 0px 1px 23px 0px rgba(0, 0, 0, 0.75);*/
    }
    
    .article .title {
        color: #ffffff;
    }
    
    .article .card-header {
        background-color: #fff!important;
    }
    
    .article .subtitle {
        color: #e0e1e2;
    }
    
    .article .article-body {
        min-height: 700px;
    }
    
    .article .loading {
        background-color: #f7f7f7;
    }
    
    .article .link {
        cursor: pointer;
    }
    
    .article .tags {
        margin: 0;
        min-height: 65px;
    }
    
    .article .tags .badge {
        text-transform: none !important;
        color: #ffffff !important;
        margin: 0 3px 3px 0;
        padding: 0.3rem 0.6rem;
        font-size: 80%;
        -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=70)";
        filter: alpha(opacity=70);
        -moz-opacity: 0.7;
        -khtml-opacity: 0.7;
        opacity: 0.7;
    }
    
    .article .btn-badge,
    .article .badge {
        -webkit-border-radius: 10rem !important;
        -moz-border-radius: 10rem !important;
        border-radius: 10rem !important;
    }
    
    .article .cursor-pointer {
        cursor: pointer;
    }
    
    .card {
        border-radius: 0;
    }

    .card-article .card-footer {
        padding: .75rem 1.5rem;
    }

    .card-article .card-footer:last-child{
        border-radius: 0;
    }

    .card-how_to_access {
        font-size: 80%;
        font-weight: 400;
        border-top: .0625rem solid rgba(0,0,0,0.05);
    }
    
    .card-tags .card-header {
        padding: .75rem 1.5rem;
    }

    .text-magenta {
        color: #EC008C;
    }

    @media(max-width:575px) {}
    
    @media(min-width:576px) and (max-width:767px) {}
    
    @media(min-width:768px) and (max-width:991px) {}
    
    @media(min-width:992px) and (max-width:1199px) {}
    
    @media(min-width:1200px) {}
</style>

<script>
    import axios from 'axios'
    import {
        library
    }
    from '@fortawesome/fontawesome-svg-core'
    import {
        faUser, faLock, faLockOpen
    }
    from '@fortawesome/free-solid-svg-icons'
    import {
        FontAwesomeIcon
    }
    from '@fortawesome/vue-fontawesome'
    library.add(faUser)
    library.add(faLock)
    library.add(faLockOpen)

    export default {
        components: {
            library,
            faUser,
            faLock,
            faLockOpen,
            FontAwesomeIcon
        },
        created() {
            window.scrollTo(0, 0);
        },
        mounted() {
            if (this.$store.state.subtitle_store)
                this.subtitle = this.$store.state.subtitle_store
            else this.get_page_subtitle()
            this.get_post()
        },
        methods: {
            get_page_subtitle() {
                    this.error = null
                    axios.get(this.api + 'page/subtitle-pages')
                        .then(response => {
                            this.subtitle = response.data.content
                            this.$store.state.subtitle_store = this.subtitle
                        })
                },
                get_post() {
                    this.error = this.post = null
                    this.loading = true
                    axios.get(this.api + 'content/' + this.$route.params.slug)
                        .then(response => {
                            this.loading = false
                            this.post = response.data
                            this.title = this.post.title
                            this.description = this.post.abstract
                            document.title = this.post.title
                            document.getElementsByTagName('meta')["description"].content = this.post.abstract.substr(0, 150)
                        })
                },
                search(key, value) {
                    if (typeof key != 'string') key = key[0]
                    this.$router.push({
                        path: '/home',
                        query: {
                            [key]: value
                        }
                    })
                },
                back() {
                    this.$router.go(-1)
                },
                ten_number(value) {
                    if (parseInt(value) < 10) return '0' + value
                    return value
                },
                getMonth(value) {
                    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
                    return months[value]
                }
        },
        head: {
            title: function() {
                return {
                    inner: 'Article'
                }
            },
            meta: function() {
                return [{
                    name: 'description',
                    content: ''
                }]
            }
        },
        data() {
            return {
                api: require('../../package.json').api,
                subtitle: '',
                error: null,
                loading: false,
                post: null,
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Article.vue